// Central feature-flag registry. Every flag referenced anywhere in the
// codebase MUST have a row here; bootstrap will validate this invariant.
// See DOCS/architecture/primitives/feature-flag.md.
//
// Adding a flag = adding a descriptor in one of the domain files below.
// Flipping a flag = a config change at runtime, not a code change.
import { FeatureFlagDescriptor } from '../primitives/feature-flag.js';
import { COMMUNITY_FEATURE_FLAGS } from './registry-community.js';
import { CONTENT_FEATURE_FLAGS } from './registry-content.js';
import { CORE_FEATURE_FLAGS } from './registry-core.js';
import { PLATFORM_FEATURE_FLAGS } from './registry-platform.js';
export const FEATURE_FLAGS = [
    ...CORE_FEATURE_FLAGS,
    ...COMMUNITY_FEATURE_FLAGS,
    ...CONTENT_FEATURE_FLAGS,
    ...PLATFORM_FEATURE_FLAGS,
];
const KEYS = new Set(FEATURE_FLAGS.map((f) => f.key));
/** Bootstrap-time invariant check — call once on app start. */
export function assertFlagRegistryIsConsistent() {
    const seen = new Set();
    for (const f of FEATURE_FLAGS) {
        if (seen.has(f.key)) {
            throw new Error(`feature-flags: duplicate key '${f.key}'`);
        }
        seen.add(f.key);
    }
    for (const f of FEATURE_FLAGS) {
        const result = FeatureFlagDescriptor.safeParse(f);
        if (!result.success) {
            throw new Error(`feature-flags: '${f.key}' invalid — ${result.error.message}`);
        }
    }
}
/** Type guard for caller-provided strings (forms, admin UI). */
export function isKnownFlag(key) {
    return KEYS.has(key);
}
//# sourceMappingURL=registry.js.map